export default __webpack_public_path__ + "static/media/all.e5b36f77.png";